import React, { useEffect, useState } from 'react';
import '../../Styles/Styles.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom'; 
import { useCookies } from 'react-cookie';
import { toast } from 'react-toastify';
import CssClass from "../../Styles/common.module.css";
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { GetPageAuthorityFn } from "../../Common/authority";
import AllowanceRateUpdate from '../../Components/MasterSetup/AllowanceRate/AllowanceRateUpdate';
import AllowanceRateDelete from '../../Components/MasterSetup/AllowanceRate/AllowanceRateDelete';
import AllowanceRateActivator from '../../Components/MasterSetup/AllowanceRate/AllowanceRateActivator';
import BackModal from '../../Components/BasicElements/BackModal.js';
import ConfirmModal from '../../Components/BasicElements/ConfirmModal.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquarePlus, faPenToSquare, faTrashCan, faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';

const PAGE_NAME = "Allowance Rate.js";
const MODULE_ID = "WEB_MST_003";

const AllowanceRate = (props) => {
	const navigate = useNavigate();
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [showActivator, setShowActivator] = useState(false);
	const [showUpdate, setShowUpdate] = useState(false);
	const [showDelete, setShowDelete] = useState(false);
	const [showBackModal, setShowBackModal] = useState(false);
	const [confirmRowData, setConfirmRowData] = useState(null);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [selectedAllowanceRate, setSelectedAllowanceRate] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loadingText, setLoadingText] = useState("Loading....")
	const [reload, setReload] = useState(false);
	const [allData, setAllData] = useState([]);
	const [editData, setEditData] = useState([]);
	const [departmentList, setDepartmentList] = useState([]);
	const [dayTypeList, setDayTypeList] = useState([]);
	const [workLocationList, setWorkLocationList] = useState([]);
	const [allowanceTypeList, setAllowanceTypeList] = useState([]);
	const [selectedDepartment, setSelectedDepartment] = useState([]);
	const [selectedDayType, setSelectedDayType] = useState([]);
	const [selectedWorkLocation, setSelectedWorkLocation] = useState([]);
	const [selectedAllowanceType, setSelectedAllowanceType] = useState([]);
	const [hasChanges, setHasChanges] = useState(false);
	const [inputError, setInputError] = useState([]);
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [globalFilterValue, setGlobalFilterValue] = useState('');
	const [filters, setFilters] = useState({
		global: { value: null, matchMode: FilterMatchMode.CONTAINS },
		DEPT_NAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
		DAY_TYPE_NAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
		WORK_LOCATION_NAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
		ALLOWANCE_TYPE_NAME: { value: null, matchMode: FilterMatchMode.CONTAINS },
	});

	//#region Authority
	const [actionAuthority, setActionAuthority] = useState({
		READ: "N",
		WRITE: "N",
		READALL: "N",
	});
		
	useEffect(() => {
		let promise = GetPageAuthorityFn(userId, MODULE_ID);
		promise.then(
			(result) => {
				setActionAuthority(result);
				if (result.READ === "N") {
					navigate("/Dashboard");
				}
			},
			(error) => {
				setActionAuthority({
					READ: "N",
					WRITE: "N",
					READALL: "N",
				});
				common.c_LogWebError(PAGE_NAME, "GetPageAuthorityFn", error);
				toast.error(error);
				navigate("/Dashboard");
			}
		);
	}, [userId, navigate]);
	//#endregion

	useEffect(() => {
		if(actionAuthority.READ === 'Y') {
			let functionName = "useEffect Get Allowance Rate List";
			try {
				setLoading(true);
				setLoadingText("Getting Allowance Rate List, Please wait...");
				setAllData([]);
				const listItems = [];

				http
					.get("api/allowanceRate/GetAllowanceRate?_sysUser=" + userId, 
							{ timeout: 100000})
					.then((response) => {
						if (response.data.length > 0) {
							response.data.forEach((data) => {
								const date = new Date(data.UPDATE_DATETIME);
								const formattedDate =
									date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB', {
										hour12: true,
										hour: '2-digit',
										minute: '2-digit',
									}).toUpperCase();

								listItems.push({
									key: data.ALLOWANCE_RATE_MST_ID,
									ALLOWANCE_RATE_MST_ID: data.ALLOWANCE_RATE_MST_ID,
									DEPT_ID: data.DEPT_ID,
									DEPT_NAME: data.DEPT_NAME,
									DAY_TYPE: data.DAY_TYPE,
									DAY_TYPE_NAME: data.DAY_TYPE_NAME,
									WORK_LOCATION: data.WORK_LOCATION,
									WORK_LOCATION_NAME: data.WORK_LOCATION_NAME,
									ALLOWANCE_TYPE: data.ALLOWANCE_TYPE,
									ALLOWANCE_TYPE_NAME: data.ALLOWANCE_TYPE_NAME,
									HOUR_FROM: data.HOUR_FROM,
									HOUR_TO: data.HOUR_TO,
									THRESHOLD_HOUR: data.THRESHOLD_HOUR,
									STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
									AMOUNT: data.AMOUNT,
									REMARK: data.REMARK,
									UPDATE_DATETIME_RAW: data.UPDATE_DATETIME,
									UPDATE_DATETIME: formattedDate,
									UPDATE_ID: data.UPDATE_ID,
								});
							});
						}
						setAllData(listItems);
					})
				.catch((err) => {
					toast.error("Error on getting allowance rate list. Please try again.");
					common.c_LogWebError(PAGE_NAME, functionName, err);
				})
				.finally(() => {
					setLoading(false);
					setLoadingText("Loading...");
				});
			} catch (err) {
				toast.error("Error on getting allowance rate list. Please try again.");
				common.c_LogWebError(PAGE_NAME, functionName, err);
			}
		}
	}, [reload, actionAuthority, userId]);

	useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Department list";
			const listItems = [];
			http
				.get("api/allowanceRate/GetDeptList?_sysUser=" + userId, { timeout: 100000 })
				.then((response) => {
				const listItems = response.data.map(department => ({
					key: department.DEPT_ID,
					value: department.DEPT_NAME,
					label: `${department.DEPT_NAME}`
				}));
				setDepartmentList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting department list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting department list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	}, []);

  const deptFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={departmentList}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select dept"
      />
    );
  };

	useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Day Type list";
			const listItems = [];
			http
				.get("api/allowanceRate/GetDayType?_sysUser=" + userId, { timeout: 100000 })
				.then((response) => {
				const listItems = response.data.map(dayType => ({
					key: dayType.CATEGORY_TYPE_MST_ID,
					value: dayType.CATEGORY_TYPE_NAME,
					label: `${dayType.CATEGORY_TYPE_NAME}`
				}));
				setDayTypeList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting day type list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting day type list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	}, []);

  const dayTypeFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={dayTypeList}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select day type"
      />
    );
  };

	useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Work Location list";
			const listItems = [];
			http
				.get("api/allowanceRate/GetWorkLocation?_sysUser=" + userId, { timeout: 100000 })
				.then((response) => {
				const listItems = response.data.map(workLocation => ({
					key: workLocation.CATEGORY_TYPE_MST_ID,
					value: workLocation.CATEGORY_TYPE_NAME,
					label: `${workLocation.CATEGORY_TYPE_NAME}`
				}));
				setWorkLocationList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting work location list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting work location list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	}, []);

  const workLocationFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={workLocationList}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select work location"
      />
    );
  };
		 
	useEffect(() => {
		let functionName = "";
		try {
			functionName = "Get Allowance Type list";
			const listItems = [];
			http
				.get("api/allowanceRate/GetAllowanceType?_sysUser=" + userId, { timeout: 100000 })
				.then((response) => {
				const listItems = response.data.map(allowanceType => ({
					key: allowanceType.CATEGORY_TYPE_MST_ID,
					value: allowanceType.CATEGORY_TYPE_NAME,
					label: `${allowanceType.CATEGORY_TYPE_NAME}`
				}));
				setAllowanceTypeList(listItems);
			})
			.catch((err) => {
				toast.error("Error on getting allowance type list. Please try again.");
				common.c_LogWebError(props.page, functionName, err);
			})
		} catch (err) {
			toast.error("Error on getting user allowance type list. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	}, []);

  const allowanceTypeFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={allowanceTypeList}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder="Select allowance type"
      />
    );
  };

	function registerNewAllowanceRate(rowData) {
		let functionName = "";
		try {
			functionName = props.page + registerNewAllowanceRate.name;
			setLoading(true);
			setLoadingText("Registering New Allowance Rate, PLease wait....")

			const data = {
				DEPT_ID: rowData.DEPT_ID,
				DAY_TYPE: rowData.DAY_TYPE,
				WORK_LOCATION: rowData.WORK_LOCATION,
				ALLOWANCE_TYPE: rowData.ALLOWANCE_TYPE,
				HOUR_FROM: rowData.HOUR_FROM ? rowData.HOUR_FROM : "N/A",
				HOUR_TO: rowData.HOUR_TO ? rowData.HOUR_TO : "N/A",
				THRESHOLD_HOUR: rowData.THRESHOLD_HOUR ? rowData.THRESHOLD_HOUR : "N/A",
				AMOUNT: rowData.AMOUNT,
				REMARK: rowData.REMARK,
				ACTIVE_FLAG: "Y", 
				DELETE_FLAG: "N", 
				UPDATE_ID: userId,
				FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: MODULE_ID },
			};
			
			http
				.post("api/allowanceRate/RegisterAllowanceRate", data, { timeout: 10000 })
				.then((response) => {
					toast.success("Allowance Rate is successfully inserted.");
					onReloadHandler();
				})
				.catch((err) => {
					toast.error("Failed to insert allowance rate. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					setLoading(false);
					setLoadingText("Loading...");
				});
		} catch (err) {
			toast.error("Failed to insert allowance rate. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};
		
	const inputRequiredHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;

		if (name != "Remark") {
			if (val.length === 0 || val.trim().length === 0) {
				setInputError((prevState) => ({
					...prevState,
					[id]: `${name} could not be empty.`,
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					[id]: "",
				}));
			}
		}

		setAllData((prevState) => {
			const updated = [...prevState];
			const rowIndex = updated.findIndex(row => row.isNew);
			if (rowIndex !== -1) {
				updated[rowIndex] = {
					...updated[rowIndex],
					[id]: val,
				};
			}
			return updated;
		});

		setHasChanges(true);
	};

	const inputTimeHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;
    
    const timePattern = /^(?:\d{1,4})(?:\.\d{0,2})?$/;

    const isValid = val === "" || timePattern.test(val);

		if  (!isValid) {
      return;
    } 

		setAllData((prevState) => {
			const updated = [...prevState];
			const rowIndex = updated.findIndex(row => row.isNew);
			if (rowIndex !== -1) {
				updated[rowIndex] = {
					...updated[rowIndex],
					[id]: val,
				};
			}
			return updated;
		});

		setHasChanges(true);
  }

	const inputAmountHandler = (event) => {
		const name = event.target.name;
		const id = event.target.id;
		const val = event.target.value;
    
    const decimalPattern = /^(0|[1-9]\d*)(\.\d{0,2})?$/;

    const isValid = val === "" || decimalPattern.test(val);

		if (val.length === 0 || val.trim().length === 0) {
			setInputError((prevState) => ({
				...prevState,
				[id]: `${name} could not be empty.`,
			}));
		} else if (!isValid) {
      return;
    } else {
			setInputError((prevState) => ({
				...prevState,
				[id]: "",
			}));
		}
		setAllData((prevState) => {
			const updated = [...prevState];
			const rowIndex = updated.findIndex(row => row.isNew);
			if (rowIndex !== -1) {
				updated[rowIndex] = {
					...updated[rowIndex],
					[id]: val,
				};
			}
			return updated;
		});

		setHasChanges(true);
  }

	const selectDeptHandler = (e) => {
		const val = e.value;

		if (val && Object.keys(val).length > 0) {
			setInputError((prevState) => ({
				...prevState,
				DEPT_ID: "",
			}));
		} else {
			setInputError((prevState) => ({
				...prevState,
				DEPT_ID: "Department could not be empty.",
			}));
		}

		setAllData((prevState) => {
			const updated = [...prevState];
			const rowIndex = updated.findIndex((row) => row.isNew);
			if (rowIndex !== -1) {
				updated[rowIndex] = {
					...updated[rowIndex],
					DEPT_ID: val,
					DEPT_NAME: departmentList.find((d) => d.key === val)?.label || '',
				};
			}
			return updated;
		});

		setSelectedDepartment(val);
		setHasChanges(true);
	};
		
	const selectDayTypeHandler = (e) => {
		const val = e.value;

		if (val && Object.keys(val).length > 0) {
			setInputError((prevState) => ({
				...prevState,
				DAY_TYPE: "",
			}));
		} else {
			setInputError((prevState) => ({
				...prevState,
				DAY_TYPE: "Day Type could not be empty.",
			}));
		}

		setAllData((prevState) => {
			const updated = [...prevState];
			const rowIndex = updated.findIndex((row) => row.isNew);
			if (rowIndex !== -1) {
				updated[rowIndex] = {
					...updated[rowIndex],
					DAY_TYPE: val,
					DAY_TYPE_NAME: dayTypeList.find((d) => d.key === val)?.label || '',
				};
			}
			return updated;
		});

		setSelectedDayType(val);
		setHasChanges(true);
	};
		
	const selectWorkLocationHandler = (e) => {
		const val = e.value;

		if (val && Object.keys(val).length > 0) {
			setInputError((prevState) => ({
				...prevState,
				WORK_LOCATION: "",
			}));
		} else {
			setInputError((prevState) => ({
				...prevState,
				WORK_LOCATION: "Work Location could not be empty.",
			}));
		}

		setAllData((prevState) => {
			const updated = [...prevState];
			const rowIndex = updated.findIndex((row) => row.isNew);
			if (rowIndex !== -1) {
				updated[rowIndex] = {
					...updated[rowIndex],
					WORK_LOCATION: val,
					WORK_LOCATION_NAME: workLocationList.find((d) => d.key === val)?.label || '',
				};
			}
			return updated;
		});

		setSelectedWorkLocation(val);
		setHasChanges(true);
	};
		
	const selectAllowanceTypeHandler = (e) => {
		const val = e.value;

		if (val && Object.keys(val).length > 0) {
			setInputError((prevState) => ({
				...prevState,
				ALLOWANCE_TYPE: "",
			}));
		} else {
			setInputError((prevState) => ({
				...prevState,
				ALLOWANCE_TYPE: "Allowance Type could not be empty.",
			}));
		}

		setAllData((prevState) => {
			const updated = [...prevState];
			const rowIndex = updated.findIndex((row) => row.isNew);
			if (rowIndex !== -1) {
				updated[rowIndex] = {
					...updated[rowIndex],
					ALLOWANCE_TYPE: val,
					ALLOWANCE_TYPE_NAME: allowanceTypeList.find((d) => d.key === val)?.label || '',
				};
			}
			return updated;
		});

		setSelectedAllowanceType(val);
		setHasChanges(true);
	};

	const onReloadHandler = () => {
		setReload(!reload);
	};

	const onLoadingHandler = (load, text) => {
		setLoading(load);
		setLoadingText(text);
	};

	const showUpdateModal = (e, row) => {
		setShowUpdate(!showUpdate);
		setEditData(row);
	};

	const hideUpdateModal = () => {
		setShowUpdate(!showUpdate);
		setEditData(null);
	};

	const showDeleteModal = (row) => {
		setShowDelete(true);
		setEditData(row);
	};

	const hideDeleteModal = () => {
		setShowDelete(false);
		setEditData(null);
	};
	
	const showActivatorModal = (e, row) => {
		setShowActivator(!showActivator);
		setEditData(row);
	};

	const hideActivatorModal = () => {
		setShowActivator(!showActivator);
		setEditData(null);
	};

	const handleBack = (index) => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			const updated = [...allData];
			updated.splice(index, 1);
			setAllData(updated);
			setInputError([]);
		}
	};

  const handleConfirmBack = (index) => {
		const updated = [...allData];
		updated.splice(index, 1);
		setAllData(updated);
		setShowBackModal(false); // Hide back modal
		setInputError([]);
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

	const handleConfirm = (rowData) => {
		let flag = true;
		const updatedErrors = {};
		
		const newRow = allData.find((row) => row.isNew);
		if (!newRow) return;

		if (!newRow.DEPT_ID) {
			flag = false;
			updatedErrors.DEPT_ID = "Department could not be empty.";
		}

		if (!newRow.DAY_TYPE) {
			flag = false;
			updatedErrors.DAY_TYPE = "Day Type could not be empty.";
		}

		if (!newRow.WORK_LOCATION) {
			flag = false;
			updatedErrors.WORK_LOCATION = "Work Location could not be empty.";
		}

		if (!newRow.ALLOWANCE_TYPE) {
			flag = false;
			updatedErrors.ALLOWANCE_TYPE = "Allowance Type could not be empty.";
		}

		if (!newRow.AMOUNT || newRow.AMOUNT.trim() === "") {
			flag = false;
			updatedErrors.AMOUNT = "Amount could not be empty.";
		}

		setInputError((prev) => ({ ...prev, ...updatedErrors }));

		if (!flag) {
			setAllData((prevState) => {
				const updated = [...prevState];
				const rowIndex = updated.findIndex((row) => row.isNew);
				if (rowIndex !== -1) {
					updated[rowIndex] = {
						...updated[rowIndex],
						__FORCE_UPDATE__: new Date().getTime(),
					};
				}
				return updated;
			});
			return;
		}

		setConfirmRowData(rowData);
		setShowConfirmModal(true);
  };

  const handleConfirmModal = () => {
    registerNewAllowanceRate(confirmRowData);
		setConfirmRowData(null);
    setShowConfirmModal(false); // Hide confirm modal
  };

	const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide confirm modal
  };
	
	const onGlobalFilterChange = (e) => {
		const value = e.target.value;
		let _filters = { ...filters };
	
		if (!_filters['global']) {
			_filters['global'] = { value: null, matchMode: FilterMatchMode.CONTAINS };
		}
	
		_filters['global'].value = value;
	
		setFilters(_filters);
		setGlobalFilterValue(value);
	};
		
	const renderHeader = () => {
		return (
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
				<span className="text-lg font-semibold" style={{ fontSize: '22px' }}>Allowance Rate</span>
				<IconField iconPosition="left">
					<InputIcon className="pi pi-search" />
					<InputText
						value={globalFilterValue}
						onChange={onGlobalFilterChange}
						placeholder="Search"
            className="table-search-input"
						style={{ height: '40px', fontSize: '0.9rem' }}
					/>
				</IconField>
			</div>
		);
	};

  const HighlightCell = ({ text, keyword }) => {
    if (!keyword || !text) return text;

    const regex = new RegExp(`(${keyword})`, "gi");
    const parts = text.split(regex);

    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === keyword.toLowerCase() ? (
            <span key={i} className="highlight-keyword">{part}</span>
          ) : (
            part
          )
        )}
      </>
    );
  };
	
	const TruncatedText = ({ text = '', maxLength = 60 }) => {
		const [expanded, setExpanded] = useState(false);

		if (!text) return null;

		const isLong = text.length > maxLength;
		const displayText = expanded || !isLong ? text : text.slice(0, maxLength) + '...';

		return (
			<div>
				<span>{displayText}</span>
				{isLong && (
					<span
						onClick={() => setExpanded((prev) => !prev)}
						style={{ color: '#007bff', cursor: 'pointer', marginLeft: '5px' }}
					>
						{expanded ? 'Show less' : 'Read more'}
					</span>
				)}
			</div>
		);
	};

	const handleAddRow = () => {
		const isNewExist = allData.some((row) => row.isNew);
  	if (isNewExist) return;
		
		const newRow = {
			ALLOWANCE_RATE_MST_ID: '',
			DEPT_NAME: '',
			DAY_TYPE_NAME: '',
			WORK_LOCATION_NAME: '',
			ALLOWANCE_TYPE_NAME: '',
			HOUR_FROM: '',
			HOUR_TO: '',
			THRESHOLD_HOUR: '',
			STATUS: '',
			REMARK: '',
			isNew: true,
		};
		setAllData([newRow, ...allData]);
	};
	//#endregion

	return (
		<>
		<div className={`${CssClass.cardTwo} ${CssClass.tableCardTwo}`}>
			<div style={{ width: "100%" }}>
				<DataTable value={allData} dataKey="ALLOWANCE_RATE_MST_ID" header={renderHeader()} filters={filters} filterDisplay="row" 
					onFilter={(e) => { 
            const newFilters = e.filters; 
            setFilters(newFilters); 
            const globalKeyword = newFilters.global?.value || '';
            const updated = allData.map(item => ({ ...item, __FILTER_KEYWORD__: { DEPT_NAME: newFilters.DEPT_NAME?.value || globalKeyword, 
              DAY_TYPE_NAME: newFilters.DAY_TYPE_NAME?.value || globalKeyword, WORK_LOCATION_NAME: newFilters.WORK_LOCATION_NAME?.value || globalKeyword, 
							ALLOWANCE_TYPE_NAME: newFilters.ALLOWANCE_TYPE_NAME?.value || globalKeyword  }})); 
            setAllData(updated); 
          }}
					selectionMode="multiple" selection={selectedAllowanceRate} onSelectionChange={(e) => setSelectedAllowanceRate(e.value)}
					globalFilter={globalFilterValue} globalFilterFields={['DEPT_NAME', 'DAY_TYPE_NAME', 'WORK_LOCATION_NAME', 'ALLOWANCE_TYPE_NAME']} 
					loading={loading} removableSort emptyMessage="No allowance rate found." first={currentPage * rowsPerPage}
					paginator rows={rowsPerPage} onPage={(e) => { setCurrentPage(e.page); setRowsPerPage(e.rows); }} rowsPerPageOptions={[10, 20, 30, 40, 50]} 
					scrollable scrollHeight="700px" showGridlines className="datatable" tableStyle={{ minWidth: '120rem' }}
				>
					<Column
						header="Action"
						{...(actionAuthority.WRITE === 'Y' && {
							filter: true,
							filterElement: (
								<button
									onClick={handleAddRow}
									style={{
										alignItems: 'center',
										marginLeft: '30px',
										padding: '8px',
										width: '90px',
										borderRadius: '5px',
										color: 'white',
										backgroundColor: '#1873e1',
									}}
								>
									<FontAwesomeIcon icon={faSquarePlus} />
									<span>&nbsp; ADD</span>
								</button>
							),
							showFilterMatchModes: false,
							showFilterOperator: false,
							showFilterMenu: false,
						})}
						body={(rowData) => {
							if (rowData.isNew) {
								return (
									<>
										<div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
											<span title="Save">
												<Comp.Button
													id="btnSave"
													type="general"
													onClick={() => handleConfirm(rowData)}
													style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
												>
													<FontAwesomeIcon icon={faCheck} />
												</Comp.Button>
											</span>
											<span title="Cancel">
												<Comp.Button
													id="btnCancel"
													type="general"
													onClick={() => handleBack(rowData)}
													style={{ width: "50px", height: "35px", marginTop: "2px", marginBottom: "2px", backgroundColor: "#d40b0b" }}
												>
													<FontAwesomeIcon icon={faXmark} />
												</Comp.Button>
											</span>
										</div>
									</>
								);
							}
							return (
								<div style={{ textAlign: "-webkit-center" }} className={CssClass.tdBtnActionWrapperTwo}>
                  {(actionAuthority.WRITE === "Y")&& (
										<span title="Modify">
											<Comp.Button
												id="btnEdit"
												type="general"
												onClick={(e) => showUpdateModal(e, rowData)}
												style={{ width: "55px", height: "35px", marginTop: "2px", marginBottom: "2px" }}
											>
												<FontAwesomeIcon icon={faPenToSquare} />
											</Comp.Button>
										</span>
                  )}
                  {(actionAuthority.WRITE === "Y")&& (
										<span title="Delete">
											<Comp.Button
												id="btnDelete"
												type="delete"
												onClick={() => showDeleteModal(rowData)}
												style={{ width: "55px", height: "35px" }}
											>
												<FontAwesomeIcon icon={faTrashCan} />
											</Comp.Button>
										</span>
                  )}
								</div>
							);
						}}
					/>
					<Column
						header="#"
						body={(rowData, options) => options.rowIndex + 1}
						style={{ width: '3rem', height: "40px", textAlign: 'center' }}
					/>
					<Column field="DEPT_NAME" header="Dept." filter filterElement={deptFilterTemplate} sortable style={{ width: '160px' }}
						body={(rowData) => 
              rowData.isNew ? (
								<div>
									<Dropdown
										id="DEPT_ID"
										name="Department"
										value={rowData.DEPT_ID}
										options={departmentList}
										optionLabel="label"
										optionValue="key"
										onChange={selectDeptHandler}
										errorMessage={inputError.DEPT_ID}
										style={{ width: '100%', height: '40px', alignItems: 'center' }}
									/>
									{inputError.DEPT_ID && (
										<small className="p-error">{inputError.DEPT_ID}</small>
									)}
								</div>
							) : (
								<HighlightCell text={rowData.DEPT_NAME} keyword={rowData.__FILTER_KEYWORD__?.DEPT_NAME || ''} />
							)
            }
					/>
					<Column field="DAY_TYPE_NAME" header="Day Type" filter filterElement={dayTypeFilterTemplate} sortable style={{ width: '160px' }}
						body={(rowData) =>
							rowData.isNew ? (
								<div>
									<Dropdown
										id="DAY_TYPE"
										name="Day Type"
										value={rowData.DAY_TYPE}
										options={dayTypeList}
										optionLabel="label"
										optionValue="key"
										onChange={selectDayTypeHandler}
										errorMessage={inputError.DAY_TYPE}
										style={{ width: '100%', height: '40px', alignItems: 'center' }}
									/>
									{inputError.DAY_TYPE && (
										<small className="p-error">{inputError.DAY_TYPE}</small>
									)}
								</div>
							) : (
								<HighlightCell text={rowData.DAY_TYPE_NAME} keyword={rowData.__FILTER_KEYWORD__?.DAY_TYPE_NAME || ''} />
							)
						}
					/>
					<Column field="WORK_LOCATION_NAME" header="Work Location" filter filterElement={workLocationFilterTemplate} sortable style={{ width: '160px' }}
						body={(rowData) =>
							rowData.isNew ? (
								<div>
									<Dropdown
										id="WORK_LOCATION"
										name="Work Location"
										value={rowData.WORK_LOCATION}
										options={workLocationList}
										optionLabel="label"
										optionValue="key"
										onChange={selectWorkLocationHandler}
										errorMessage={inputError.WORK_LOCATION}
										style={{ width: '100%', height: '40px', alignItems: 'center' }}
									/>
									{inputError.WORK_LOCATION && (
										<small className="p-error">{inputError.WORK_LOCATION}</small>
									)}
								</div>
							) : (
								<HighlightCell text={rowData.WORK_LOCATION_NAME} keyword={rowData.__FILTER_KEYWORD__?.WORK_LOCATION_NAME || ''} />
							)
						}
					/>
					<Column field="ALLOWANCE_TYPE_NAME" header="Allowance Type" filter filterElement={allowanceTypeFilterTemplate} sortable style={{ width: '160px' }}
						body={(rowData) => 
							rowData.isNew ? (
								<div>
									<Dropdown
										id="ALLOWANCE_TYPE"
										name="Allowance Type"
										value={rowData.ALLOWANCE_TYPE}
										options={allowanceTypeList}
										optionLabel="label"
										optionValue="key"
										onChange={selectAllowanceTypeHandler}
										errorMessage={inputError.ALLOWANCE_TYPE}
										style={{ width: '100%', height: '40px', alignItems: 'center' }}
									/>
									{inputError.ALLOWANCE_TYPE && (
										<small className="p-error">{inputError.ALLOWANCE_TYPE}</small>
									)}
								</div>
							) : (
								<HighlightCell text={rowData.ALLOWANCE_TYPE_NAME} keyword={rowData.__FILTER_KEYWORD__?.ALLOWANCE_TYPE_NAME || ''} />
							)
						}
					/>
					<Column field="HOUR_FROM" header="From Time" sortable style={{ width: '120px' }}
						body={(rowData) =>
							rowData.isNew ? (
								<div class="allowanceInput">
									<Comp.Input
										id="HOUR_FROM"
										name="Hour From"
										label=""
										type="text"
										value={rowData.HOUR_FROM}
										onChange={inputTimeHandler}
										errorMessage={inputError.HOUR_FROM}
									/>
									</div>
							) : (
								rowData.HOUR_FROM
							)
						}
					/>
					<Column field="HOUR_TO" header="To Time" sortable style={{ width: '120px' }}
						body={(rowData) =>
							rowData.isNew ? (
								<div class="allowanceInput">
									<Comp.Input
										id="HOUR_TO"
										name="Hour To"
										label=""
										type="text"
										value={rowData.HOUR_TO}
										onChange={inputTimeHandler}
										errorMessage={inputError.HOUR_TO}
									/>
								</div>
							) : (
								rowData.HOUR_TO
							)
						}
					/>
					<Column field="THRESHOLD_HOUR" header="Threshold Hour" sortable style={{ width: '120px' }}
						body={(rowData) =>
							rowData.isNew ? (
								<div class="allowanceInput">
									<Comp.Input
										id="THRESHOLD_HOUR"
										name="Threshold Hour"
										label=""
										type="text"
										value={rowData.THRESHOLD_HOUR}
										onChange={inputTimeHandler}
										errorMessage={inputError.THRESHOLD_HOUR}
									/>
								</div>
							) : (
								rowData.THRESHOLD_HOUR
							)
						}
					/>
					<Column field="AMOUNT" header="Amount" sortable style={{ width: '120px' }}
						body={(rowData) =>
							rowData.isNew ? (
								<div class="allowanceInput">
									<Comp.Input
										id="AMOUNT"
										name="Amount"
										label=""
										type="text"
										value={rowData.AMOUNT}
										onChange={inputAmountHandler}
										errorMessage={inputError.AMOUNT}
									/>
								</div>
							) : (
								`RM ${rowData.AMOUNT ?? '0.00'}`
							)
						}
					/>
					<Column
						field="STATUS"
						header="Status"
						style={{ textAlign: 'center', width: '60px' }}
						body={(rowData) => {
							const className =
								rowData.STATUS === "Active"
									? CssClass.activeStatus
									: CssClass.inactiveStatus;

							const handleToggle = (e, rowData) => {
								showActivatorModal(e, rowData);
							};

							if (rowData.isNew) {
								return (
									<div className={CssClass.toggleWrapper}>
										<label className={CssClass.switch}>
											<input
												type="checkbox"
												checked={true}
												disabled={true}
												onChange={() => {}}
											/>
											<span className={CssClass.sliderRound}></span>
										</label>
									</div>
								);
							}

							return (
								<div className={CssClass.toggleWrapper}>
									<label className={CssClass.switch}>
										<input
											type="checkbox"
											checked={rowData.STATUS === "Active"}
											onChange={(e) => handleToggle(e, rowData)}
										/>
										<span className={CssClass.sliderRound}></span>
									</label>
								</div>
							);
						}
					}
					/>
					<Column field="REMARK" header="Remark" sortable style={{ width: '400px' }}
						body={(rowData) =>
							rowData.isNew ? (
								<div class="allowanceInput">
									<Comp.Input
										id="REMARK"
										name="Remark"
										label=""
										type="text"
										value={rowData.REMARK}
										onChange={inputRequiredHandler}
										errorMessage={inputError.REMARK}
									/>
								</div>
							) : (
								<TruncatedText text={rowData.REMARK} />
							)
						}
					/>
				</DataTable>
			</div>
			<br/>
		</div>

		{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
		<Comp.AlertPopup />

		<AllowanceRateUpdate
			page={props.page}
			module={MODULE_ID}
			showHide={showUpdate}
			editData={editData}
			onHide={hideUpdateModal}
			onReload={onReloadHandler}
			onLoading={onLoadingHandler}
		/>

		{showDelete && (
			<AllowanceRateDelete
				page={props.page}
				module={MODULE_ID}
				showHide={showDelete}
				editData={editData}
				onHide={hideDeleteModal}
				onReload={onReloadHandler}
				onLoading={onLoadingHandler}
			/>
		)}

		{showActivator && (
			<AllowanceRateActivator
				page={props.page}
				module={MODULE_ID}
				showHide={showActivator}
				editData={editData}
				onHide={hideActivatorModal}
				onReload={onReloadHandler}
				onLoading={onLoadingHandler}
			/>
		)}

    {/* Confirmation Modal */}
    <BackModal
      show={showBackModal}
      onHide={handleConfirmBackCancel}
      onConfirm={handleConfirmBack}
      prop="Confirm Navigation"
    >
      Are you sure you want to go cancel? Your changes may be lost.
    </BackModal>

    <ConfirmModal
      show={showConfirmModal}
      onHide={handleConfirmModalClose}
      onConfirm={handleConfirmModal}
      prop="Confirm to save"
    >
      Are you sure you want to create new allowance rate?
    </ConfirmModal>
		</>
	);
};

export default AllowanceRate;